import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import './AdminLayout.css';

// Icon components
const DashboardIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" fill="currentColor"/>
  </svg>
);

const OrdersIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M7 4V2C7 1.45 7.45 1 8 1h8c.55 0 1 .45 1 1v2h5c.55 0 1 .45 1 1s-.45 1-1 1h-1v13c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V6H2c-.55 0-1-.45-1-1s.45-1 1-1h5zM9 3v1h6V3H9zm2 12c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1z" fill="currentColor"/>
  </svg>
);

const UberIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 2L2 7v10c0 5.55 3.84 7.74 9 9 5.16-1.26 9-3.45 9-9V7l-10-5zM12 8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8-1.34-8-4v-2c0 2.66 5.33 4 8 4s8-1.34 8-4v2c0 2.66-5.33 4-8 4z" fill="currentColor"/>
  </svg>
);

const CustomersIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 8H17c-.8 0-1.54.37-2.01 1l-2.94 3.83c-.2.26-.2.62 0 .88l2.94 3.83c.47.63 1.21 1 2.01 1h1.54c.8 0 1.51-.37 1.96-1L22 15v7h-2zm-8-2v-2h2v-2h-2v-2h2v-2h-2V8h2V6H8.5C7.67 6 7 6.67 7 7.5S7.67 9 8.5 9H9v2H8.5C7.67 11 7 11.67 7 12.5S7.67 14 8.5 14H9v2H8.5C7.67 16 7 16.67 7 17.5S7.67 19 8.5 19H12z" fill="currentColor"/>
  </svg>
);

const ReportsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z" fill="currentColor"/>
  </svg>
);

const InventoryIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z" fill="currentColor"/>
  </svg>
);

const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 0 0 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z" fill="currentColor"/>
  </svg>
);

const ManageIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.82,11.69,4.82,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z" fill="currentColor"/>
  </svg>
);

const ArrowIcon = ({ expanded }) => (
  <svg 
    width="12" 
    height="12" 
    viewBox="0 0 24 24" 
    fill="none" 
    style={{ 
      transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
      transition: 'transform 0.2s ease'
    }}
  >
    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" fill="currentColor"/>
  </svg>
);

// Additional icons for better categorization
const OperationsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 2L2 7v10c0 5.55 3.84 7.74 9 9 5.16-1.26 9-3.45 9-9V7l-10-5z" fill="currentColor"/>
  </svg>
);

const BusinessIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z" fill="currentColor"/>
  </svg>
);

const StaffIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="currentColor"/>
  </svg>
);

const AdminIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 1L3 5v6c0 5.55 3.84 7.74 9 9 5.16-1.26 9-3.45 9-9V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" fill="currentColor"/>
  </svg>
);

const sections = [
  // Always at top
  {
    label: 'Dashboard',
    to: '/admin',
    icon: <DashboardIcon />,
    priority: 'high'
  },
  
  // Operations - Daily Use
  {
    label: 'Operations',
    icon: <OperationsIcon />,
    priority: 'high',
    isSection: true,
    children: [
      { label: 'Orders', to: '/admin/orders', icon: <OrdersIcon />, priority: 'high' },
      { label: 'Low Stock Alert', to: '/admin/low-stock', priority: 'high' },
    ]
  },
  
  // Customer Management - Frequent Use
  {
    label: 'Customer Management',
    icon: <CustomersIcon />,
    priority: 'high',
    isSection: true,
    children: [
      { label: 'Customers Overview', to: '/admin/customers', priority: 'medium' },
      { label: 'Contact Messages', to: '/admin/contact-messages', priority: 'high' },
      { label: 'Wholesale', to: '/admin/wholesale', priority: 'medium' },
      { label: 'Waiting List', to: '/admin/waiting-list', priority: 'medium' },
      { label: 'Seated List', to: '/admin/seated-list', priority: 'medium' },
    ]
  },
  
  // Business Intelligence - Weekly Use
  {
    label: 'Business Intelligence',
    icon: <BusinessIcon />,
    priority: 'medium',
    isSection: true,
    children: [
      { label: 'Sales Report', to: '/admin/salesreport', priority: 'medium' },
      { label: 'Weekly Sales', to: '/admin/weekly-sales-report', priority: 'medium' },
      { label: 'Accounting System', to: '/admin/accounting', priority: 'medium' },
    ]
  },
  
  // Staff Management - Less Frequent
  {
    label: 'Staff Management',
    icon: <StaffIcon />,
    priority: 'medium',
    isSection: true,
    children: [
      { label: 'User Management', to: '/admin/users', priority: 'high' },
      { label: 'Menu Management', to: '/admin/menu', priority: 'low' },
      { label: 'Product Template', to: '/admin/product-template', priority: 'medium' },
      { label: 'Available Products', to: '/admin/available-products', priority: 'low' },
      { label: 'Staff Roles', priority: 'low', children: [
        { label: 'Waiter', to: '/admin/waiter' },
        { label: 'Cashier', to: '/admin/cashier' },
      ]},
    ]
  },
  
  // Administration - Least Frequent
  {
    label: 'Administration',
    icon: <AdminIcon />,
    priority: 'low',
    isSection: true,
    children: [
      { label: 'Product Management', to: '/admin/products', priority: 'low' },
      { label: 'Wholesale Inventory', to: '/admin/wholesale-inventory', priority: 'low' },
      { label: 'Shops Management', to: '/admin/shops', priority: 'low' },
      { label: 'Legal Management', to: '/admin/legal', priority: 'low' },
      { label: 'HomePage Edit', to: '/admin/homepage', priority: 'low' },
      { label: 'Official Letters', priority: 'medium', children: [
        { label: 'Letter Templates', to: '/admin/letter-templates' },
        { label: 'Generate Letter', to: '/admin/generate-letter' },
        { label: 'Generated Letters', to: '/admin/generated-letters' },
      ]},
    ]
  },
];

export default function AdminLayout() {
  const [open, setOpen] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerClosing, setDrawerClosing] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();
  const [isDesktop, setIsDesktop] = useState(typeof window !== 'undefined' ? window.innerWidth > 768 : true);
  const [pageTitle, setPageTitle] = useState('Dashboard');

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Set page title based on location
    const path = location.pathname;
    if (path.includes('/admin/orders')) setPageTitle('Orders');
    else if (path.includes('/admin/customers')) setPageTitle('Customers');
    else if (path.includes('/admin/reports')) setPageTitle('Reports');
    else if (path.includes('/admin/inventory')) setPageTitle('Inventory');
    else if (path.includes('/admin/menu')) setPageTitle('Menu');
    else if (path.includes('/admin/manage')) setPageTitle('Manage');
    else setPageTitle('Dashboard');
  }, [location]);

  // Add admin-page class to body when component mounts
  useEffect(() => {
    document.body.classList.add('admin-page');
    return () => {
      document.body.classList.remove('admin-page');
    };
  }, []);

  const toggleSection = (label) => {
    setOpen((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  const closeDrawer = () => {
    setDrawerClosing(true);
    setTimeout(() => {
      setDrawerOpen(false);
      setDrawerClosing(false);
    }, 300); // Match animation duration
  };

  return (
    <div className="admin-layout">
      {/* Mobile Overlay */}
      {drawerOpen && <div className="admin-overlay" onClick={closeDrawer}></div>}
      
      {/* Sidebar (desktop only) */}
      {isDesktop && (
        <aside className={`admin-sidebar ${sidebarCollapsed ? 'collapsed' : ''} ${drawerOpen ? 'mobile-open' : ''}`}>
          {isDesktop && (
            <div className="sidebar-header">
              <img src="/images/logo.png" alt="GREY" className="sidebar-logo" />
              <button 
                className="sidebar-toggle"
                onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          )}
          <nav className="sidebar-nav">
            {sections.map((section) => (
              section.children ? (
                <div key={section.label} className={`nav-section ${section.isSection ? 'section-group' : ''} priority-${section.priority}`}>
                  {section.isSection && (
                    <div className="section-header">
                      <span className="section-title">{section.label}</span>
                    </div>
                  )}
                  {!section.isSection && (
                    <button
                      className={`nav-item nav-parent ${open[section.label] ? 'expanded' : ''}`}
                      onClick={() => toggleSection(section.label)}
                    >
                      <div className="nav-item-content">
                        <span className="nav-icon">{section.icon}</span>
                        <span className="nav-label">{section.label}</span>
                      </div>
                      <svg 
                        className={`nav-chevron ${open[section.label] ? 'rotated' : ''}`}
                        width="16" 
                        height="16" 
                        viewBox="0 0 16 16"
                      >
                        <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                      </svg>
                    </button>
                  )}
                  <div className={`nav-submenu ${section.isSection ? 'always-visible' : ''} ${!section.isSection && open[section.label] ? 'open' : ''}`}>
                    {section.children.map((child) => (
                      child.children ? (
                        <div key={child.label} className="nav-subsection">
                          <button
                            className={`nav-subitem nav-sub-parent ${open[child.label] ? 'expanded' : ''}`}
                            onClick={() => toggleSection(child.label)}
                          >
                            {child.label}
                            <svg 
                              className={`nav-chevron-small ${open[child.label] ? 'rotated' : ''}`}
                              width="12" 
                              height="12" 
                              viewBox="0 0 16 16"
                            >
                              <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                            </svg>
                          </button>
                          {open[child.label] && (
                            <div className="nav-sub-submenu">
                              {child.children.map((subChild) => (
                                <NavLink
                                  key={subChild.to}
                                  to={subChild.to}
                                  className={({ isActive }) =>
                                    `nav-sub-subitem ${isActive ? 'active' : ''}`
                                  }
                                  onClick={closeDrawer}
                                >
                                  {subChild.label}
                                </NavLink>
                              ))}
                            </div>
                          )}
                        </div>
                      ) : (
                        <NavLink
                          key={child.to || child.label}
                          to={child.to}
                          className={({ isActive }) =>
                            `nav-subitem ${isActive ? 'active' : ''}`
                          }
                          onClick={closeDrawer}
                        >
                          <div className="nav-subitem-content">
                            {child.icon && <span className="nav-subicon">{child.icon}</span>}
                            <span className="nav-sublabel">{child.label}</span>
                          </div>
                        </NavLink>
                      )
                    ))}
                  </div>
                </div>
              ) : (
                <NavLink
                  key={section.to}
                  to={section.to}
                  className={({ isActive }) =>
                    `nav-item ${isActive ? 'active' : ''} priority-${section.priority}`
                  }
                  onClick={closeDrawer}
                >
                  <div className="nav-item-content">
                    <span className="nav-icon">{section.icon}</span>
                    <span className="nav-label">{section.label}</span>
                  </div>
                </NavLink>
              )
            ))}
          </nav>
        </aside>
      )}
      {/* Mobile header removed - no header needed on mobile */}
      
      {/* Floating Hamburger Button for Mobile */}
      {!isDesktop && !drawerOpen && (
        <button className="admin-floating-menu-btn" onClick={() => setDrawerOpen(true)} aria-label="Open menu">
          <svg width="24" height="24" viewBox="0 0 24 24">
            <line x1="3" y1="6" x2="21" y2="6" stroke="white" strokeWidth="2" strokeLinecap="round" />
            <line x1="3" y1="12" x2="21" y2="12" stroke="white" strokeWidth="2" strokeLinecap="round" />
            <line x1="3" y1="18" x2="21" y2="18" stroke="white" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      )}
      {/* Mobile Drawer */}
      {!isDesktop && (drawerOpen || drawerClosing) && (
        <>
          <div className={`admin-mobile-overlay ${drawerClosing ? 'closing' : ''}`} onClick={closeDrawer}></div>
          <div className={`admin-mobile-drawer ${drawerClosing ? 'closing' : ''}`}>
            <button className="drawer-close-btn" onClick={closeDrawer} aria-label="Close menu">
              <svg width="28" height="28" viewBox="0 0 28 28"><line x1="6" y1="6" x2="22" y2="22" stroke="#222" strokeWidth="2" strokeLinecap="round" /><line x1="22" y1="6" x2="6" y2="22" stroke="#222" strokeWidth="2" strokeLinecap="round" /></svg>
            </button>
            
            <div className="drawer-logo">
              <img src="/images/logo.png" alt="Grey Official" className="drawer-logo-img" />
            </div>
            
            <nav className="drawer-nav">
              {sections.map((section) => (
                section.children ? (
                  <div key={section.label} className={`drawer-section ${section.isSection ? 'section-group' : ''}`}>
                    <span className={`drawer-section-label ${section.isSection ? 'group-header' : ''}`}>
                      {section.label}
                    </span>
                    <div className="drawer-submenu">
                      {section.children.map((child) => (
                        child.children ? (
                          <div key={child.label} className="drawer-subsection">
                            <span className="drawer-subsection-label">{child.label}</span>
                            <div className="drawer-sub-submenu">
                              {child.children.map((subChild) => (
                                <NavLink
                                  key={subChild.to}
                                  to={subChild.to}
                                  className={({ isActive }) => `drawer-sublink ${isActive ? 'active' : ''}`}
                                  onClick={closeDrawer}
                                >
                                  {subChild.label}
                                </NavLink>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <NavLink
                            key={child.to || child.label}
                            to={child.to}
                            className={({ isActive }) => `drawer-link ${isActive ? 'active' : ''}`}
                            onClick={closeDrawer}
                          >
                            {child.label}
                          </NavLink>
                        )
                      ))}
                    </div>
                  </div>
                ) : (
                  <NavLink
                    key={section.to}
                    to={section.to}
                    className={({ isActive }) => `drawer-link ${isActive ? 'active' : ''}`}
                    onClick={closeDrawer}
                  >
                    {section.label}
                  </NavLink>
                )
              ))}
            </nav>
          </div>
        </>
      )}
      {/* Main Content */}
      <main className={`admin-main ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Outlet />
      </main>
    </div>
  );
} 